__turbopack_context__.v({
  "feedbackButton": "styles-module__5iDpBG__feedbackButton",
});
